import { Systems } from "./systems";

export enum QuiltedHealthValueSets {
  Edema = `${Systems.QH}/fhir/ValueSet/edema`,
  EncounterServiceType = `${Systems.QH}/fhir/ValueSet/encounter-service-type`,
  EncounterTypeEarlyCare = `${Systems.QH}/fhir/ValueSet/encounter-type-early-care`,
  EncounterTypeGynecological = `${Systems.QH}/fhir/ValueSet/encounter-type-gynecological`,
  EncounterTypeNewbornIPP = `${Systems.QH}/fhir/ValueSet/encounter-type-newborn-ipp`,
  EncounterTypeNewbornPostpartum = `${Systems.QH}/fhir/ValueSet/encounter-type-newborn-postpartum`,
  EncounterTypeOther = `${Systems.QH}/fhir/ValueSet/encounter-type-other`,
  EncounterTypePostpartum = `${Systems.QH}/fhir/ValueSet/encounter-type-postpartum`,
  EncounterTypePrenatal = `${Systems.QH}/fhir/ValueSet/encounter-type-prenatal`,
  FetalMovement = `${Systems.QH}/fhir/ValueSet/fetal-movement`,
  UrineGlucose = `${Systems.QH}/fhir/ValueSet/urine-glucose`,
  UrineProtein = `${Systems.QH}/fhir/ValueSet/urine-protein`,
  ProblemType = `${Systems.QH}/fhir/ValueSet/problem-type`,
  ResourceClientVisibility = `${Systems.QH}/fhir/ValueSet/resource-client-visibility`,
  MedicationStatementStatus = `${Systems.QH}/fhir/ValueSet/medication-statement-status`,
  ContactPointUse = `${Systems.QH}/fhir/ValueSet/contact-point-use`,
  Country = `${Systems.QH}/fhir/ValueSet/country`,
  TemperatureUnits = `${Systems.QH}/fhir/ValueSet/temperature-units`,
  RelationToContractions = `${Systems.QH}/fhir/ValueSet/relation-to-contractions`,
  ListeningDevice = `${Systems.QH}/fhir/ValueSet/listening-device`,
  ContractionsStrength = `${Systems.QH}/fhir/ValueSet/contractions-strength`,
  CervixConsistency = `${Systems.QH}/fhir/ValueSet/cervix-consistency`,
  CervixLocation = `${Systems.QH}/fhir/ValueSet/cervix-location`,
  ROMConfirmedBy = `${Systems.QH}/fhir/ValueSet/rom-confirmed-by`,
  ROMMethod = `${Systems.QH}/fhir/ValueSet/rom-method`,
  MembraneFluidColor = `${Systems.QH}/fhir/ValueSet/membrane-fluid-color`,
  LocationSite = `${Systems.QH}/fhir/ValueSet/location-site`,
  LaborPosition = `${Systems.QH}/fhir/ValueSet/labor-position`,
  FetalPresentation = `${Systems.QH}/fhir/ValueSet/fetal-presentation`,
  BirthingType = `${Systems.QH}/fhir/ValueSet/birthing-type`,
  FamilyMembersAll = `${Systems.QH}/fhir/ValueSet/family-members-all`,
  PregnancyFamilyMembers = `${Systems.QH}/fhir/ValueSet/pregnancy-family-members`,
  ShoulderDystociaManeuvers = `${Systems.QH}/fhir/ValueSet/shoulder-dystocia-maneuvers`,
  TransportType = `${Systems.QH}/fhir/ValueSet/qh-transport-type`,
  TransportReasonIntrapartum = `${Systems.QH}/fhir/ValueSet/qh-transport-reason-intrapartum`,
  TransportReasonPostpartum = `${Systems.QH}/fhir/ValueSet/qh-transport-reason-postpartum`,
  TransportReasonNewborn = `${Systems.QH}/fhir/ValueSet/qh-transport-reason-newborn`,
  TransportCondition = `${Systems.QH}/fhir/ValueSet/qh-transport-condition`,
  TransportDisposition = `${Systems.QH}/fhir/ValueSet/qh-transport-disposition`,
  EpisodeOfCareType = `${Systems.QH}/fhir/ValueSet/qh-episode-of-care-type`,
  MedicationForm = `${Systems.QH}/fhir/ValueSet/qh-medication-form`,
  MedicationDuration = `${Systems.QH}/fhir/ValueSet/qh-medication-duration`,
  MedicationFrequency = `${Systems.QH}/fhir/ValueSet/qh-medication-frequency`,
  MedicationInstruction = `${Systems.QH}/fhir/ValueSet/qh-medication-instruction`,
  MedicationPrnReason = `${Systems.QH}/fhir/ValueSet/qh-medication-prn-reason`,
  TherapyComplementaryReason = `${Systems.QH}/fhir/ValueSet/qh-therapy-complementary-reason`,
  MedicationRoute = `${Systems.QH}/fhir/ValueSet/qh-medication-route`,
  MedicationDoseUnits = `${Systems.QH}/fhir/ValueSet/qh-medication-dose-units`,
  AppointmentType = `${Systems.QH}/fhir/ValueSet/qh-appointment-type`,
  AppointmentTypeKind = `${Systems.QH}/fhir/ValueSet/qh-appointment-type-kind`,
  AppointmentReoccurrence = `${Systems.QH}/fhir/ValueSet/qh-appointment-reoccurrence`,
  AppointmentCancellationNote = `${Systems.QH}/fhir/ValueSet/qh-appointment-cancellation-note`,
  BreastSurgeryType = `${Systems.QH}/fhir/ValueSet/qh-breast-surgery-type`,
  AbdomenNormal = `${Systems.QH}/fhir/ValueSet/pe-abdomen-normal`,
  AbdomenNotNormal = `${Systems.QH}/fhir/ValueSet/pe-abdomen-not-normal`,
  BackNormal = `${Systems.QH}/fhir/ValueSet/pe-back-normal`,
  BackNotNormal = `${Systems.QH}/fhir/ValueSet/pe-back-not-normal`,
  BreastNormal = `${Systems.QH}/fhir/ValueSet/pe-breast-normal`,
  BreastNotNormal = `${Systems.QH}/fhir/ValueSet/pe-breast-not-normal`,
  ExtremitiesNormal = `${Systems.QH}/fhir/ValueSet/pe-extremities-normal`,
  ExtremitiesNotNormal = `${Systems.QH}/fhir/ValueSet/pe-extremities-not-normal`,
  NeurologicNormal = `${Systems.QH}/fhir/ValueSet/pe-neurologic-normal`,
  NeurologicNotNormal = `${Systems.QH}/fhir/ValueSet/pe-neurologic-not-normal`,
  GeneralAppearanceNormal = `${Systems.QH}/fhir/ValueSet/pe-general-appearance-normal`,
  GeneralAppearanceNotNormal = `${Systems.QH}/fhir/ValueSet/pe-general-appearance-not-normal`,
  GenitourinaryCervixNormal = `${Systems.QH}/fhir/ValueSet/pe-genitourinary-cervix-normal`,
  GenitourinaryCervixNotNormal = `${Systems.QH}/fhir/ValueSet/pe-genitourinary-cervix-not-normal`,
  GenitourinaryPelvicFloorNormal = `${Systems.QH}/fhir/ValueSet/pe-genitourinary-pelvic-floor-normal`,
  GenitourinaryPelvicFloorNotNormal = `${Systems.QH}/fhir/ValueSet/pe-genitourinary-pelvic-floor-not-normal`,
  GenitourinaryRectumNormal = `${Systems.QH}/fhir/ValueSet/pe-genitourinary-rectum-normal`,
  GenitourinaryRectumNotNormal = `${Systems.QH}/fhir/ValueSet/pe-genitourinary-rectum-not-normal`,
  GenitourinaryUterusAdnexaNormal = `${Systems.QH}/fhir/ValueSet/pe-genitourinary-uterus-adnexa-normal`,
  GenitourinaryUterusAdnexaNotNormal = `${Systems.QH}/fhir/ValueSet/pe-genitourinary-uterus-adnexa-not-normal`,
  GenitourinaryVaginaNormal = `${Systems.QH}/fhir/ValueSet/pe-genitourinary-vagina-normal`,
  GenitourinaryVaginaNotNormal = `${Systems.QH}/fhir/ValueSet/pe-genitourinary-vagina-not-normal`,
  GenitourinaryVulvaPerineumNormal = `${Systems.QH}/fhir/ValueSet/pe-genitourinary-vulva-perineum-normal`,
  GenitourinaryVulvaPerineumNotNormal = `${Systems.QH}/fhir/ValueSet/pe-genitourinary-vulva-perineum-not-normal`,
  HeartNormal = `${Systems.QH}/fhir/ValueSet/pe-heart-normal`,
  HeartNotNormal = `${Systems.QH}/fhir/ValueSet/pe-heart-not-normal`,
  HEENTEarsNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-ears-normal`,
  HEENTEarsNotNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-ears-not-normal`,
  HEENTEyesNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-eyes-normal`,
  HEENTEyesNotNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-eyes-not-normal`,
  HEENTHeadNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-head-normal`,
  HEENTHeadNotNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-head-not-normal`,
  HEENTMouthNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-mouth-normal`,
  HEENTMouthNotNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-mouth-not-normal`,
  HEENTNeckNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-neck-normal`,
  HEENTNeckNotNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-neck-not-normal`,
  HEENTNoseNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-nose-normal`,
  HEENTNoseNotNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-nose-not-normal`,
  HEENTPharynxNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-pharynx-normal`,
  HEENTPharynxNotNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-pharynx-not-normal`,
  HEENTTeethGumsNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-teeth-gums-normal`,
  HEENTTeethGumsNotNormal = `${Systems.QH}/fhir/ValueSet/pe-heent-teeth-gums-not-normal`,
  LungsNormal = `${Systems.QH}/fhir/ValueSet/pe-lungs-normal`,
  LungsNotNormal = `${Systems.QH}/fhir/ValueSet/pe-lungs-not-normal`,
  SkinNormal = `${Systems.QH}/fhir/ValueSet/pe-skin-normal`,
  SkinNotNormal = `${Systems.QH}/fhir/ValueSet/pe-skin-not-normal`,
  PsychiatricNormal = `${Systems.QH}/fhir/ValueSet/pe-psychiatric-normal`,
  PsychiatricNotNormal = `${Systems.QH}/fhir/ValueSet/pe-psychiatric-not-normal`,
  MusculoskeletalNormal = `${Systems.QH}/fhir/ValueSet/pe-musculoskeletal-normal`,
  MusculoskeletalNotNormal = `${Systems.QH}/fhir/ValueSet/pe-musculoskeletal-not-normal`,
  BabyColor = `${Systems.QH}/fhir/ValueSet/baby-color`,
  ResuscitationType = `${Systems.QH}/fhir/ValueSet/resuscitation-type`,
  FundusMeasurement = `${Systems.QH}/fhir/ValueSet/fundus-measurement`,
  FundalTexture = `${Systems.QH}/fhir/ValueSet/fundal-texture`,
  TemperatureMethod = `${Systems.QH}/fhir/ValueSet/temperature-method`,
  PlacentaPresentation = `${Systems.QH}/fhir/ValueSet/placenta-presentation`,
  PlacentaDeliveryMethod = `${Systems.QH}/fhir/ValueSet/placenta-delivery-method`,
  NewbornSystemsAbdomenNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-abdomen-normal`,
  NewbornSystemsAnusNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-anus-normal`,
  NewbornSystemsAnusNotNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-anus-not-normal`,
  NewbornSystemsAppearanceNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-appearance-normal`,
  NewbornSystemsAppearanceNotNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-appearance-not-normal`,
  NewbornSystemsEarsNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-ears-normal`,
  NewbornSystemsEyesNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-eyes-normal`,
  NewbornSystemsEyesNotNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-eyes-not-normal`,
  NewbornSystemsGenitourinaryNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-genitourinary-normal`,
  NewbornSystemsGenitourinaryNotNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-genitourinary-not-normal`,
  NewbornSystemsHeadAndNeckNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-head-and-neck-normal`,
  NewbornSystemsHeadAndNeckNotNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-head-and-neck-not-normal`,
  NewbornSystemsHipsNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-hips-normal`,
  NewbornSystemsHipsNotNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-hips-not-normal`,
  NewbornSystemsLungsNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-lungs-normal`,
  NewbornSystemsLungsNotNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-lungs-not-normal`,
  NewbornSystemsMouthAndPalateNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-mouth-and-palate-normal`,
  NewbornSystemsMusculoskeletalNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-musculoskeletal-normal`,
  NewbornSystemsMusculoskeletalNotNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-musculoskeletal-not-normal`,
  NewbornSystemsPulsesNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-pulses-normal`,
  NewbornSystemsReflexesNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-reflexes-normal`,
  NewbornSystemsReflexesNotNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-reflexes-not-normal`,
  NewbornSystemsSkinAndBirthmarksNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-skin-and-birthmarks-normal`,
  NewbornSystemsSkinAndBirthmarksNotNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-skin-and-birthmarks-not-normal`,
  NewbornSystemsSpineNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-spine-normal`,
  NewbornSystemsSpineNotNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-spine-not-normal`,
  NewbornSystemsToneNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-tone-normal`,
  NewbornSystemsUmbilicusNormal = `${Systems.QH}/fhir/ValueSet/newborn-systems-umbilicus-normal`,
  PerineumStatus = `${Systems.QH}/fhir/ValueSet/perineum-status`,
  FeedingType = `${Systems.QH}/fhir/ValueSet/feeding-type`,
  PostpartumMedicationRoute = `${Systems.QH}/fhir/ValueSet/postpartum-medication-route`,
  PostpartumMedicationFrequency = `${Systems.QH}/fhir/ValueSet/postpartum-medication-frequency`,
  PostpartumBowelNormal = `${Systems.QH}/fhir/ValueSet/postpartum-bowel-normal`,
  PostpartumBowelNotNormal = `${Systems.QH}/fhir/ValueSet/postpartum-bowel-not-normal`,
  PostpartumUrineNormal = `${Systems.QH}/fhir/ValueSet/postpartum-urine-normal`,
  PostpartumUrineNotNormal = `${Systems.QH}/fhir/ValueSet/postpartum-urine-not-normal`,
  NewbornApgarType = `${Systems.QH}/fhir/ValueSet/newborn-apgar-type`,
  NewbornColor = `${Systems.QH}/fhir/ValueSet/newborn-color`,
  NewbornMuscleTone = `${Systems.QH}/fhir/ValueSet/newborn-muscle-tone`,
  NewbornReflexStimuli = `${Systems.QH}/fhir/ValueSet/newborn-reflex-stimuli`,
  NewbornRespiratoryEffort = `${Systems.QH}/fhir/ValueSet/newborn-respiratory-effort`,
  NewbornHeartRate = `${Systems.QH}/fhir/ValueSet/newborn-heart-rate`,
  UploadedDocumentTypes = `${Systems.QH}/fhir/ValueSet/uploaded-document-types`,
  NewbornPostpartumStateOfNewborn = `${Systems.QH}/fhir/ValueSet/newborn-postpartum-state-of-newborn`,
  NewbornPostpartumStateOfNewbornSex = `${Systems.QH}/fhir/ValueSet/newborn-postpartum-state-of-newborn-sex`,
  EncounterTypeTransferOfCare = `${Systems.QH}/fhir/ValueSet/encounter-type-transfer-of-care`,
  TransferDetailsType = `${Systems.QH}/fhir/ValueSet/qh-transfer-details-type`,
  TransferDetailsTypeAntepartumOptions = `${Systems.QH}/fhir/ValueSet/qh-antepartum-transfer-type-antepartum-options`,
  TransferDetailsTypeIntrapartumOptions = `${Systems.QH}/fhir/ValueSet/qh-intrapartum-transfer-type-options`,
  ImmediatePostpartumTransferTypeOptions = `${Systems.QH}/fhir/ValueSet/qh-immediate-postpartum-transfer-type-options`,
  TransferMode = `${Systems.QH}/fhir/ValueSet/qh-transfer-mode`,
  PatientConditionOptions = `${Systems.QH}/fhir/ValueSet/qh-patient-condition-options`,
  UrgencyOptions = `${Systems.QH}/fhir/ValueSet/qh-urgency-options`,
  ImmediateNewbornTransferTypeOptions = `${Systems.QH}/fhir/ValueSet/qh-immediate-newborn-transfer-type-options`,
  NewbornTransferTypeOptions = `${Systems.QH}/fhir/ValueSet/qh-newborn-transfer-type-options`,
  PostpartumTransferTypeOptions = `${Systems.QH}/fhir/ValueSet/qh-postpartum-transfer-type-options`,
  AllergyIntolerance = `${Systems.QH}/fhir/ValueSet/allergyintolerance`,
  AllergyIntoleranceReactions = `${Systems.QH}/fhir/ValueSet/allergyintolerance-reactions`,
  PractitionerPermission = `${Systems.QH}/fhir/ValueSet/practitioner-permission`,
  NewbornPostpartumSupplementUnit = `${Systems.QH}/fhir/ValueSet/newborn-postpartum-supplement-unit`,
  NewbornPostpartumVitalsJaundice = `${Systems.QH}/fhir/ValueSet/newborn-postpartum-vitals-jaundice`,
  BloodType = `${Systems.QH}/fhir/ValueSet/blood-type`,
  ManualLabTests = `${Systems.QH}/fhir/ValueSet/manual-lab-tests`,
  ImagingStudies = `${Systems.QH}/fhir/ValueSet/imaging-studies`,
  EduResourceAttachmentTypes = `${Systems.QH}/fhir/ValueSet/edu-resource-attachment-types`,
  EduResourceWeek = `${Systems.QH}/fhir/ValueSet/edu-resource-week`,
  EduResourceTopic = `${Systems.QH}/fhir/ValueSet/edu-resource-topic`,
  EduFolderPurpose = `${Systems.QH}/fhir/ValueSet/edu-folder-purpose`,
  FolderInitialSettings = `${Systems.QH}/fhir/ValueSet/folder-initial-settings`,
  HighRiskComplications = `${Systems.QH}/fhir/ValueSet/high-risk-complications`,
  PregnancySupervision = `${Systems.QH}/fhir/ValueSet/pregnancy-supervision`,
  PrenatalScreeningCounseling = `${Systems.QH}/fhir/ValueSet/prenatal-screening-counseling`,
  PrenatalConditions = `${Systems.QH}/fhir/ValueSet/prenatal-conditions`,
  LaborDeliveryEncounters = `${Systems.QH}/fhir/ValueSet/labor-delivery-encounters`,
  Gyn = `${Systems.QH}/fhir/ValueSet/gyn`,
  MenstrualHormoneDisorders = `${Systems.QH}/fhir/ValueSet/menstrual-hormone-disorders`,
  MentalHealth = `${Systems.QH}/fhir/ValueSet/mental-health`,
  PostpartumComplications = `${Systems.QH}/fhir/ValueSet/postpartum-complications`,
  PostpartumICDCodes = `${Systems.QH}/fhir/ValueSet/postpartum-and-lactation`,
  NewbornConditions = `${Systems.QH}/fhir/ValueSet/newborn-conditions`,
  WellNewbornEncounters = `${Systems.QH}/fhir/ValueSet/well-newborn-encounters`,
  ContraceptionDiagnoses = `${Systems.QH}/fhir/ValueSet/contraception-diagnoses`,
  DietaryRestrictions = `${Systems.QH}/fhir/ValueSet/dietary-restrictions`,
}

export enum QuiltedHealthCodeSystems {
  FormsLibraryContext = `${Systems.QH}/fhir/CodeSystem/forms-library-context`,
  FormsLibrarySection = `${Systems.QH}/fhir/CodeSystem/forms-library-section`,
  EncounterLocation = `${Systems.QH}/fhir/CodeSystem/encounter-location`,
  EncounterPractitionerType = `${Systems.QH}/fhir/CodeSystem/encounter-practitioner-type`,
  EncounterServiceType = `${Systems.QH}/fhir/CodeSystem/encounter-service-type`,
  EncounterSignedAndLockedBy = `${Systems.QH}/fhir/CodeSystem/encounter-signed-and-locked-by`,
  ContractionsStrength = `${Systems.QH}/fhir/CodeSystem/contractions-strength`,
  CervixConsistency = `${Systems.QH}/fhir/CodeSystem/cervix-consistency`,
  CervixLocation = `${Systems.QH}/fhir/CodeSystem/cervix-location`,
  MembraneFluidColor = `${Systems.QH}/fhir/CodeSystem/membrane-fluid-color`,
  ROMMethod = `${Systems.QH}/fhir/CodeSystem/rom-method`,
  ROMConfirmedBy = `${Systems.QH}/fhir/CodeSystem/rom-confirmed-by`,
  EpisodeOfCareType = `${Systems.QH}/fhir/CodeSystem/episode-of-care-type`,
  MedicationForm = `${Systems.QH}/fhir/CodeSystem/qh-medication-form`,
  MedicationRoute = `${Systems.QH}/fhir/CodeSystem/qh-medication-route`,
  MedicationDoseUnits = `${Systems.QH}/fhir/CodeSystem/qh-medication-dose-units`,
  MedicationDuration = `${Systems.QH}/fhir/CodeSystem/qh-medication-duration`,
  MedicationStatementStatus = `${Systems.QH}/fhir/CodeSystem/medication-statement-status`,
  MedicationFrequency = `${Systems.QH}/fhir/CodeSystem/qh-medication-frequency`,
  MedicationInstruction = `${Systems.QH}/fhir/CodeSystem/qh-medication-instruction`,
  MedicationPrnReason = `${Systems.QH}/fhir/CodeSystem/qh-medication-prn-reason`,
  TherapyComplementaryReason = `${Systems.QH}/fhir/CodeSystem/qh-therapy-complementary-reason`,
  AppointmentType = `${Systems.QH}/fhir/CodeSystem/qh-appointment-type`,
  AppointmentTypeKind = `${Systems.QH}/fhir/CodeSystem/qh-appointment-type-kind`,
  AppointmentReoccurrence = `${Systems.QH}/fhir/CodeSystem/qh-appointment-reoccurrence`,
  AppointmentCancellationNote = `${Systems.QH}/fhir/CodeSystem/qh-appointment-cancellation-note`,
  ShoulderDystociaManeuvers = `${Systems.QH}/fhir/CodeSystem/shoulder-dystocia-maneuvers`,
  BreastSurgeryType = `${Systems.QH}/fhir/CodeSystem/qh-breast-surgery-type`,
  PhysicalExamFindings = `${Systems.QH}/fhir/CodeSystem/physical-exam-findings`,
  BabyColor = `${Systems.QH}/fhir/CodeSystem/baby-color`,
  PhysicalExams = `${Systems.QH}/fhir/CodeSystem/physical-exams`,
  UsageContextType = `${Systems.QH}/fhir/CodeSystem/usage-context-type`,
  ResuscitationType = `${Systems.QH}/fhir/CodeSystem/resuscitation-type`,
  FundusMeasurement = `${Systems.QH}/fhir/CodeSystem/fundus-measurement`,
  FundalTexture = `${Systems.QH}/fhir/CodeSystem/fundal-texture`,
  TemperatureMethod = `${Systems.QH}/fhir/CodeSystem/temperature-method`,
  PlacentaPresentation = `${Systems.QH}/fhir/CodeSystem/placenta-presentation`,
  PlacentaDeliveryMethod = `${Systems.QH}/fhir/CodeSystem/placenta-delivery-method`,
  NewbornSystems = `${Systems.QH}/fhir/CodeSystem/newborn-systems`,
  NewbornSystemsFindings = `${Systems.QH}/fhir/CodeSystem/newborn-systems-findings`,
  NewbornProcedures = `${Systems.QH}/fhir/CodeSystem/newborn-procedures`,
  PerineumStatus = `${Systems.QH}/fhir/CodeSystem/perineum-status`,
  FeedingType = `${Systems.QH}/fhir/CodeSystem/feeding-type`,
  NewbornApgarType = `${Systems.QH}/fhir/CodeSystem/newborn-apgar-type`,
  NewbornColor = `${Systems.QH}/fhir/CodeSystem/newborn-color`,
  NewbornMuscleTone = `${Systems.QH}/fhir/CodeSystem/newborn-muscle-tone`,
  NewbornReflexStimuli = `${Systems.QH}/fhir/CodeSystem/newborn-reflex-stimuli`,
  NewbornRespiratoryEffort = `${Systems.QH}/fhir/CodeSystem/newborn-respiratory-effort`,
  NewbornHeartRate = `${Systems.QH}/fhir/CodeSystem/newborn-heart-rate`,
  UploadedDocumentTypes = `${Systems.QH}/fhir/CodeSystem/uploaded-document-types`,
  UploadedDocumentSource = `${Systems.QH}/fhir/CodeSystem/uploaded-document-source`,
  DocumentSecurityLabel = `${Systems.QH}/fhir/CodeSystem/document-security-label`,
  CommunicationCategories = `${Systems.QH}/fhir/CodeSystem/communication-categories`,
  CareTeamCategories = `${Systems.QH}/fhir/CodeSystem/care-team-categories`,
  NewbornPostpartumStateOfNewborn = `${Systems.QH}/fhir/CodeSystem/newborn-postpartum-state-of-newborn`,
  NewbornPostpartumStateOfNewbornSex = `${Systems.QH}/fhir/CodeSystem/newborn-postpartum-state-of-newborn-sex`,
  PractitionerPermission = `${Systems.QH}/fhir/CodeSystem/practitioner-permission`,
  PractitionerOrganizationMembership = `${Systems.QH}/fhir/CodeSystem/practitioner-organization-membership`,
  PracticeFeatureFlags = `${Systems.QH}/fhir/CodeSystem/practice-feature-flags`,
  DevelopmentFeatureFlags = `${Systems.QH}/fhir/CodeSystem/development-feature-flags`,
  NewbornPostpartumSupplementUnit = `${Systems.QH}/fhir/CodeSystem/newborn-postpartum-supplement-unit`,
  DeliveryLocationSite = `${Systems.QH}/fhir/CodeSystem/delivery-location-site`,
  NewbornPostpartumVitalsJaundice = `${Systems.QH}/fhir/CodeSystem/newborn-postpartum-vitals-jaundice`,
  DotPhraseType = `${Systems.QH}/fhir/CodeSystem/dotphrase-type`,
  DotPhraseScope = `${Systems.QH}/fhir/CodeSystem/dotphrase-scope`,
  ChecklistTemplateVisibility = `${Systems.QH}/fhir/CodeSystem/checklist-template-visibility`,
  ChecklistVisibility = `${Systems.QH}/fhir/CodeSystem/checklist-visibility`,
  BloodType = `${Systems.QH}/fhir/CodeSystem/blood-type`,
  HealthGorillaLabOrderInternalStatus = `${Systems.QH}/fhir/CodeSystem/health-gorilla-lab-order-internal-status`,
  LabTestType = `${Systems.QH}/fhir/CodeSystem/lab-test-type`,
  ManualLabResults = `${Systems.QH}/fhir/CodeSystem/manual-lab-results`,
  EduResourceAttachmentTypes = `${Systems.QH}/fhir/CodeSystem/edu-resource-attachment-types`,
  EduResourceWeek = `${Systems.QH}/fhir/CodeSystem/edu-resource-week`,
  EduResourceTopic = `${Systems.QH}/fhir/CodeSystem/edu-resource-topic`,
  BillingStatementTags = `${Systems.QH}/fhir/CodeSystem/qh-billing-statement-tags`,
  BillingServiceTags = `${Systems.QH}/fhir/CodeSystem/billing-service-tags`,
  LedgerAdjustmentReason = `${Systems.QH}/fhir/CodeSystem/ledger-adjustment-reason`,
  FacilityFee = `${Systems.QH}/fhir/CodeSystem/facility-fee`,
  EduFolderPurpose = `${Systems.QH}/fhir/CodeSystem/edu-folder-purpose`,
  FolderInitialSettings = `${Systems.QH}/fhir/CodeSystem/folder-initial-settings`,
  EDDDisplay = `${Systems.QH}/fhir/CodeSystem/edd-display`,
  OrganizationType = `${Systems.QH}/fhir/CodeSystem/organization-type`,
  FetalMovement = `${Systems.QH}/fhir/CodeSystem/fetal-movement`,
  EncounterServicesStatus = `${Systems.QH}/fhir/CodeSystem/qh-encounter-services-status`,
  FlagCategory = `${Systems.QH}/fhir/CodeSystem/qh-flag-category`,
  FlagPriority = `${Systems.QH}/fhir/CodeSystem/qh-flag-priority`,
  LibraryFlag = `${Systems.QH}/fhir/CodeSystem/qh-library-flag`,
}

/**
 * `Identifier.system` values for the billing pipeline. Every artifact a statement produces (Invoice,
 * Claim, ClaimResponse, PaymentReconciliation) copies these, so one indexed `identifier` query
 * resolves them to each other.
 */
export enum QuiltedHealthIdentifierSystems {
  /**
   * The statement family's identity — a minted, opaque UUID. A statement bundles whatever
   * charges the biller selected, across any number of Encounters, so nothing it references is
   * stable enough to identify it.
   */
  BillingIdentifier = `${Systems.QH}/fhir/billing-identifier`,
  /** The chronological, per-practice statement number. Sub-statements suffix the parent's `-N`. */
  InvoiceIdentifier = `${Systems.QH}/fhir/invoice-identifier`,
  /**
   * A captured charge's identity: the Encounter it was captured from and the Procedure it charges
   * for. Deterministic, so the create can be made conditional on it and two overlapping captures of
   * the same encounter cannot both write the same charge.
   */
  ChargeCaptureIdentifier = `${Systems.QH}/fhir/charge-capture-identifier`,
  /**
   * The biller-section row a Procedure was written for, as the id of that row's ChargeItem.
   *
   * Rows are the biller section's unit of work, and two of them can be billed under the same
   * procedure code. The key is what keeps their Procedures apart: an edit finds its own row's
   * Procedure by this identifier instead of by the code, so it cannot rewrite the Procedure another
   * row is billed under.
   */
  BillerSectionRowProcedureIdentifier = `${Systems.QH}/fhir/biller-section-row-procedure-identifier`,
  /**
   * The procedures questionnaire response a Procedure was written from, as the response's id.
   *
   * The encounter procedures bot finds the Procedure it owns by this identifier, so it never rebuilds
   * a Procedure the procedure picker wrote under the same code.
   */
  ProceduresQuestionnaireResponseIdentifier = `${Systems.QH}/fhir/procedures-questionnaire-response-identifier`,
  /** Optional reference number on a ledger Adjustment detail. */
  LedgerAdjustmentReference = `${Systems.QH}/fhir/ledger-adjustment-reference`,
}

/**
 * `Identifier.system` values for newborn patient linking (PE-5055). Applied independently to both
 * the newborn `Patient` and its `RelatedPerson(CHILD)`, each with its own copy of the identifier, so
 * either resource can be conditionally created off the same idempotency key.
 */
export enum NewbornPatientLinkingIdentifierSystems {
  /**
   * The source Birthing `QuestionnaireResponse` this newborn was created from, `value` = that
   * QuestionnaireResponse's id. The idempotency key for creating the newborn's `Patient` and
   * `RelatedPerson`, and the signal that distinguishes a reconciling edit (same value, changed
   * birth details) from a new birth (a value not seen before).
   */
  NewbornSourceQuestionnaireResponse = `${Systems.QH}/identifier/newborn-source-questionnaire-response`,
}

export enum QuiltedHealthUsageContextTypes {
  PhysicalExams = "physical-exams",
  NewbornSystems = "newborn-systems",
  NewbornProcedures = "newborn-procedures",
  LabOrderTemplates = "lab-order-templates",
  ChecklistTemplates = "checklist-templates",
}

export enum EncounterPractitionerType {
  Provider = "provider",
  BirthingAssistant = "birthing-assistant",
  Doula = "doula",
  /** Non-EHR attendees; Doula is stored as relationship-to-client extension value "Doula". */
  OthersPresent = "others-present",
  /** Practitioner who completed the labor before-charting setup */
  Participant = "participant",
  /** Who signed and locked the completed encounter */
  SignedAndLockedBy = "signed-and-locked-by",
}

export const EncounterPractitionerTypeDisplay = {
  [EncounterPractitionerType.Provider]: "Provider",
  [EncounterPractitionerType.BirthingAssistant]: "Birthing Assistant",
  [EncounterPractitionerType.Doula]: "Doula",
  [EncounterPractitionerType.OthersPresent]: "Others Present",
  [EncounterPractitionerType.Participant]: "Participant",
  [EncounterPractitionerType.SignedAndLockedBy]: "Signed and locked by",
} as const;

export enum FormsLibraryContext {
  Section = "section",
}

export enum FormsLibrarySection {
  IntakeForms = "intake-forms",
  ConsentForms = "consent-forms",
  Assessments = "assessments",
}

export enum ProblemType {
  PregnancyProblem = "forms/problems/problemType/pregnancyProblem",
  NonPregnancyProblem = "forms/problems/problemType/nonPregnancyProblem",
}

export enum ResourceClientVisibility {
  Visible = "visible",
  NotVisible = "notVisible",
}

export enum FetalHeartRateComponent {
  BeatsPerMinuteLow = "beats-per-minute-low",
  BeatsPerMinuteHigh = "beats-per-minute-high",
  DurationOfListening = "duration-of-listening",
  ListeningDevice = "listening-device",
  RelationToContractions = "relation-to-contractions",
  AccelerationsDetected = "accelerations-detected",
  DecelerationsDetected = "decelerations-detected",
  AssessBaseline = "assess-baseline",
  Baseline = "baseline",
  BaselineDurationOfListening = "baseline-duration-of-listening",
}

export enum ContractionsComponent {
  Frequency = "contractions-frequency",
  Duration = "contractions-duration",
  Strength = "contractions-strength",
  Coping = "contractions-coping",
}

export enum CervicalExamComponent {
  Dilation = "cervical-dilation",
  Effacement = "cervical-effacement",
  Station = "cervix-station",
  Consistency = "cervix-consistency",
  Location = "cervix-location",
  ActiveLabor = "cervix-active-labor",
  FetalPresentation = "fetal-presentation",
}

export enum ROMComponent {
  ConfirmedBy = "rom-confirmed-by",
  ConfirmedByOther = "rom-confirmed-by-other",
  FluidColorOther = "rom-fluid-color-other",
}

export enum LaborPositionComponent {
  ClientPosition = "client-position",
  ClientInWater = "client-in-water",
  ClientInWaterOther = "client-in-water-other",
}

export enum BirthingComponent {
  CrownDeliveredDateTime = "crown-delivery-date-time",
  HeadDeliveredDateTime = "head-delivery-date-time",
  BodyDeliveredDateTime = "body-delivery-date-time",
  BirthingType = "birthing-type",
  Position = "birthing-position",
  ClientInWater = "client-in-water",
  ClientInWaterOther = "client-in-water-other",
  FetalPresentation = "fetal-presentation",
  DeliveryMethod = "delivery-method",
  DeliveryMethodOther = "delivery-method-other",
}

export enum InputOutputComponent {
  Input = "input",
  Output = "output",
}

export enum MembranesComponent {
  Pooling = "pooling",
  Nitrazine = "nitrazine",
  FernResults = "fern-results",
  FluidColor = "LA30056-8",
  FluidColorOther = "LA30056-8-other",
}

export enum MedsTherapiesComponent {
  Medication = "meds-therapies-medication",
  Form = "meds-therapies-form",
  Duration = "meds-therapies-duration",
  Dosage = "meds-therapies-dosage",
  Frequency = "meds-therapies-frequency",
  PRN = "meds-therapies-prn",
  SpecialInstructions = "meds-therapies-special-instructions",
  Therapy = "meds-therapies-therapy",
  Reason = "meds-therapies-reason",
  IVAccess = "meds-therapies-iv-access",
  FluidVolume = "meds-therapies-fluid-volume",
}

export enum ShoulderDystociaComponent {
  Duration = "shoulder-dystocia-duration",
  Maneuvers = "shoulder-dystocia-maneuvers",
  ManeuverInitiated = "shoulder-dystocia-maneuver-initiated",
  Type = "shoulder-dystocia-type",
  Birth = "shoulder-dystocia-birth",
  BirthNotes = "shoulder-dystocia-birth-notes",
}

export enum AdmissionDischargeComponent {
  Type = "admission-discharge-type",
}

export enum EstimatedBloodLossComponent {
  Estimated = "estimated-blood-loss-estimated",
  Quantitative = "estimated-blood-loss-quantitative",
  Cumulative = "estimated-blood-loss-cumulative",
  Capture = "estimated-blood-loss-capture",
}

export enum TransportComponent {
  Type = "forms/laborFlowSheet/transport/type",
  Reason = "forms/laborFlowSheet/transport/reason",
  NewbornDisposition = "forms/laborFlowSheet/transport/disposition/newborn",
  ClientDisposition = "forms/laborFlowSheet/transport/disposition",
  NewbornDispositionOther = "transportDispositionNewbornOther",
  ClientDispositionOther = "transportDispositionClientOther",
  DecidingProvider = "transport-deciding-provider",
  Contact = "42077-8",
  TransportingFrom = "transport-transporting-from",
  HospitalName = "transport-hospital-name",
  HospitalContact = "62332-2",
  Condition = "transport-condition",
  FirstCall = "transport-first-call",
  EMSArrived = "transport-ems-arrived",
  TimeLeft = "transport-time-left",
  ArrivedAtHospital = "transport-arrived-at-hospital",
}

export enum ResuscitationComponent {
  Resuscitation = "resuscitation",
  ResuscitationType = "forms/laborFlowSheet/resuscitation/type",
  ResuscitationTypeOther = "type-other",
  ResuscitationBirth = "body-delivered-birth",
}

export enum PostpartumHemorrhageComponent {
  Duration = "postpartum-hemorrhage-duration",
  Maneuvers = "postpartum-hemorrhage-maneuvers",
}

export enum LaborFlowsheetForms {
  Contractions = "forms/laborFlowSheet/contractions",
  CervicalExam = "forms/laborFlowSheet/cervical-exam",
  ROM = "forms/laborFlowSheet/rom",
  Position = "forms/laborFlowSheet/position",
  AssessmentNote = "forms/laborFlowSheet/assessment-note",
  Birthing = "forms/laborFlowSheet/birthing",
  InputOutput = "forms/laborFlowSheet/input-output",
  Membranes = "forms/laborFlowSheet/membranes",
  MedsTherapies = "forms/laborFlowSheet/meds-therapies",
  Location = "forms/laborFlowSheet/location",
  ShoulderDystocia = "forms/laborFlowSheet/shoulderDystocia",
  AdmissionDischarge = "forms/laborFlowSheet/admissionDischarge",
  EstimatedBloodLoss = "forms/laborFlowSheet/estimatedBloodLoss",
  Transport = "forms/laborFlowSheet/transport",
  Resuscitation = "forms/laborFlowSheet/resuscitation",
  PostpartumHemorrhage = "forms/laborFlowSheet/postpartumHemorrhage",
}

export enum LocationComponent {
  LocationSite = "location-site",
  LocationSiteOther = "location-site-other",
}

export enum QuiltedHealthCodes {
  MedicaidEligibility = "forms/intake/medicaid-eligibilty",
  PaymentMethod = "forms/intake/payment-method",
  ContractionsStrengthModerate = "forms/laborFlowSheet/contractions/strength/moderate",
  ContractionsStrengthStrong = "forms/laborFlowSheet/contractions/strength/strong",
  ContractionsStrengthMild = "forms/laborFlowSheet/contractions/strength/mild",
  CervixConsistencyFirm = "forms/laborFlowSheet/cervix/consistency/firm",
  CervixConsistencyMedium = "forms/laborFlowSheet/cervix/consistency/medium",
  CervixConsistencySoft = "forms/laborFlowSheet/cervix/consistency/soft",
  CervixLocationPosterior = "forms/laborFlowSheet/cervix/location/posterior",
  CervixLocationMidline = "forms/laborFlowSheet/cervix/location/midline",
  CervixLocationAnterior = "forms/laborFlowSheet/cervix/location/anterior",
  ROMMembraneFluidColorClear = "forms/laborFlowSheet/membrane/fluidColor/clear",
  ROMMembraneFluidColorMeconiumThin = "forms/laborFlowSheet/membrane/fluidColor/meconium-thin",
  ROMMembraneFluidColorMeconiumModerate = "forms/laborFlowSheet/membrane/fluidColor/meconium-moderate",
  ROMMembraneFluidColorMeconiumThick = "forms/laborFlowSheet/membrane/fluidColor/meconium-thick",
  ROMFluidColorOther = "forms/laborFlowSheet/membrane/fluidColor/other",
  ROMConfirmedByClient = "forms/laborFlowSheet/rom/confirmedBy/client",
  ROMConfirmedByMidwife = "forms/laborFlowSheet/rom/confirmedBy/midwife",
  ROMConfirmedByPalpation = "forms/laborFlowSheet/rom/confirmedBy/palpation",
  ROMConfirmedByFern = "forms/laborFlowSheet/rom/confirmedBy/fern",
  ROMConfirmedByAmnicator = "forms/laborFlowSheet/rom/confirmedBy/amnicator",
  ROMConfirmedBySpeculum = "forms/laborFlowSheet/rom/confirmedBy/speculum",
  ROMConfirmedByOther = "forms/laborFlowSheet/rom/confirmedBy/other",
  ROMMethodSpontaneous = "forms/laborFlowSheet/rom/method/spontaneous",
  ROMMethodArtificial = "forms/laborFlowSheet/rom/method/artificial",
  ClientInWaterOther = "forms/laborFlowSheet/position/clientInWater/other",
  MedsTherapiesMedication = "forms/laborFlowSheet/meds-therapies/medication",
  MedsTherapiesForm = "forms/laborFlowSheet/meds-therapies/form",
  MedsTherapiesDuration = "forms/laborFlowSheet/meds-therapies/duration",
  MedsTherapiesDosage = "forms/laborFlowSheet/meds-therapies/dosage",
  MedsTherapiesFrequency = "forms/laborFlowSheet/meds-therapies/frequency",
  MedsTherapiesPRN = "forms/laborFlowSheet/meds-therapies/prn",
  MedsTherapiesSpecialInstructions = "forms/laborFlowSheet/meds-therapies/special-instructions",
  MedsTherapiesTherapy = "forms/laborFlowSheet/meds-therapies/therapy",
  MedsTherapiesReason = "forms/laborFlowSheet/meds-therapies/reason",
  MedsTherapiesIVAccess = "forms/laborFlowSheet/meds-therapies/iv-access",
  MedsTherapiesFluidVolume = "forms/laborFlowSheet/meds-therapies/fluid-volume",
  Location = "forms/laborFlowSheet/location",
  ShoulderDystociaDuration = "forms/laborFlowSheet/shoulder-dystocia/duration",
  ShoulderDystociaManeuvers = "forms/laborFlowSheet/shoulder-dystocia/maneuvers",
  shoulderDystociaType = "forms/laborFlowSheet/shoulder-dystocia/type",
  ShoulderDystociaBirth = "forms/laborFlowSheet/shoulder-dystocia/birth",
  ShoulderDystociaBirthNotes = "forms/laborFlowSheet/shoulder-dystocia/birth-notes",
  ManeuverMcRoberts = "forms/laborFlowSheet/shoulderDystocia/maneuvers/mcRoberts",
  ManeuverEpisiotomy = "forms/laborFlowSheet/shoulderDystocia/maneuvers/episiotomy",
  ManeuverClavicleFracture = "forms/laborFlowSheet/shoulderDystocia/maneuvers/clavicleFracture",
  BirthDateTime = "labor/birthDateTime",
  EDDDisplay = "forms/edd/display",
  Intrapartum = "forms/transferOfCare/transferDetails/type/intrapartum",
  ImmediatePostpartum = "forms/transferOfCare/transferDetails/type/immediatePostpartum",
  ImmediateNewborn = "forms/transferOfCare/transferDetails/type/immediateNewborn",
}

export enum PastPregnanciesCodes {
  NPregnancies = "pastPregnanciesOccurrences",
  NTotalPregnancies = "pastPregnanciesTotal",
  NTermPregnancies = "pastPregnanciesFullTerm",
  NPrematureBirths = "pastPregnanciesPremature",
  NInducedAbortions = "pastPregnanciesAbortions",
  NMiscarriages = "pastPregnanciesMiscarriages",
  NLivingChildren = "pastPregnanciesLivingChildren",
  NTotalAbortions = "pastPregnanciesTotalAbortions",
}

export enum UploadedDocumentTypesCodes {
  Admin = "forms/uploaded-documents/admin",
  Labs = "forms/uploaded-documents/labs",
  Imaging = "forms/uploaded-documents/imaging",
  Letters = "forms/uploaded-documents/letters",
  Billing = "forms/uploaded-documents/billing",
  Clinical = "forms/uploaded-documents/clinical",
  Other = "forms/uploaded-documents/other",
}
export const UploadedDocumentTypesDisplays = {
  [UploadedDocumentTypesCodes.Admin]: "Admin",
  [UploadedDocumentTypesCodes.Labs]: "Labs",
  [UploadedDocumentTypesCodes.Imaging]: "Imaging",
  [UploadedDocumentTypesCodes.Letters]: "Letters",
  [UploadedDocumentTypesCodes.Billing]: "Billing",
  [UploadedDocumentTypesCodes.Clinical]: "Clinical",
  [UploadedDocumentTypesCodes.Other]: "Other",
};

/**
 * `DocumentReference.category` codes on the {@link QuiltedHealthCodeSystems.UploadedDocumentSource}
 * CodeSystem — what produced the document, not what it is (see
 * {@link UploadedDocumentTypesCodes} for that).
 */
export enum UploadedDocumentSourceCodes {
  /** A billing statement PDF generated and saved via Send to Client. */
  BillingStatement = "billing-statement",
  /** A payer document, such as an ERA, that a biller attached to a statement. Practice-only. */
  BillingAttachment = "billing-attachment",
}

export enum DocumentSecurityLabelCodes {
  VisibleToClient = "forms/documentSecurityLabel/visible-to-client",
  Restricted = "forms/documentSecurityLabel/restricted",
  Deleted = "forms/documentSecurityLabel/deleted",
}

export enum CommunicationCategoryCodes {
  Inbox = "forms/communication/category/inbox",
  Thread = "forms/communication/category/thread",
}

export enum CareTeamCategoryCodes {
  PracticeWide = "forms/careTeam/category/practice-wide",
  PatientOnly = "forms/careTeam/category/patient-only",
}

export enum EncounterServiceTypeCodes {
  TransferOfCare = "forms/encounters/category/transfer-of-care",
}

export enum ChecklistCodes {
  Checklist = "forms/checklist/checklist",
  ChecklistTitle = "forms/checklist/checklist-title",
  ChecklistTask = "forms/checklist/checklist-task",
}

export enum BloodTypeCodes {
  CombinedBloodType = "combined-blood-type",
}

export enum EDDDisplayCodes {
  LMP = "forms/edd/display/lmp",
  Ultrasound = "forms/edd/display/us",
  Custom = "forms/edd/display/custom",
}

export const FAVORITES_EDU_RESOURCES_CODE = "favorites-folder";

/**
 * Every `meta.tag` code a billing statement Invoice can carry, all in the single
 * {@link QuiltedHealthCodeSystems.BillingStatementTags} CodeSystem.
 *
 * The codes fall into three independent groups, and code that writes tags must clear only the group
 * it owns rather than every tag in the system:
 *
 * - **Lifecycle** ({@link BILLING_STATEMENT_LIFECYCLE_TAGS}) — the fine-grained work-queue state
 *   that `Invoice.status`'s canonical R4 binding cannot express. Mutually exclusive; at most one is
 *   ever set. `Unsent`, `Sent` and `Paid` have no code here because `Invoice.status`
 *   (`draft`/`issued`/`balanced`) already carries them.
 * - **Archive** — presentational and reversible; orthogonal to the lifecycle.
 * - **Restart** — a one-way marker that the statement's charges were handed back to the Services
 *   tab; orthogonal to the lifecycle, whose last value it deliberately leaves in place.
 * - **Deletion** — a one-way soft delete; orthogonal to all of the above.
 */
export enum BillingStatementTag {
  /** Payer accepted the statement and is processing it. Rendered as "In Processing" in the UI. */
  InProcessing = "in-processing",
  Rejected = "rejected",
  Denied = "denied",
  /** Hidden from the default list without being voided. Reversible. */
  Archived = "archived",
  /**
   * The statement's charges were returned to the Services tab as unbilled while the statement
   * itself stayed listed. One-way, and it fixes the lifecycle status where the restart found it.
   */
  Restarted = "restarted",
  /** Soft-deleted: hidden from every list, resource intact and recoverable. One-way. */
  Deleted = "deleted",
}

/**
 * Tags for a ChargeItem (Service), carried on `meta.tag` under the BillingServiceTags
 * CodeSystem. Searchable via `_tag`.
 *
 * `Unbilled` and `Billed` mirror `ChargeItem.status` (`billable` / `billed`), which FHIR R4 does not
 * define a search parameter for; `applyChargeItemStatusTag` keeps the mirror in step on every write
 * path. `Archived` is orthogonal to both, so archiving a charge leaves its status mirror alone.
 */
export enum BillingServiceTag {
  Archived = "archived",
  Unbilled = "unbilled",
  Billed = "billed",
}

/**
 * The mutually exclusive lifecycle codes. `applyStatementStatus` clears exactly these when the
 * status changes, so the archive, restart and delete tags — which live in the same CodeSystem but
 * are orthogonal to the lifecycle — survive a status change.
 */
export const BILLING_STATEMENT_LIFECYCLE_TAGS: readonly BillingStatementTag[] = [
  BillingStatementTag.InProcessing,
  BillingStatementTag.Rejected,
  BillingStatementTag.Denied,
];
